import { Component, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDateStruct, NgbDatepickerModule, NgbDropdownModule, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../Model/Combo/combo.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { log } from 'console';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { Observable, Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { elements } from 'chart.js';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AssetService } from '../../Model/AssetModule/asset.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { event } from 'jquery';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-asset-addition-form',
  standalone: true,
  imports: [NgbDatepickerModule, FormsModule, NgSelectModule, CommonModule, DataTablesModule, NgbDropdownModule, NgbTooltipModule, ReactiveFormsModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './asset-addition-form.component.html',
  styleUrl: './asset-addition-form.component.scss'
})
export class AssetAdditionFormComponent {
  isDisabled: boolean = false;
  IsDisableAdd: boolean = true;
  user = [] as any;
  
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  model!: NgbDateStruct;
  Branch = [] as any;
  Asset = [] as any;
  MaxDate = [] as any;
  MinDate = [] as any;
  FileNameForAssetAdditionDetails: any
  AssetAdditionDetails = {
    SelectType: 'Insert',
    ESS_AssetAdditionId: 0,
    PurchaseRefNo: null,
    PurchaseDate: null as any,
    PurchaseDateObj: null as any,
    BranchId: null,
    TotalCount: 0,
    VendorName: null,
    Attachment: null as any,
    AttachmentUrl: null as any,
    ESS_AssetAdditionDetails: [] as any
  }

  // AssetDetails={
  //   ESS_AssetAdditionDetailsID:0,
  //   ESS_AssetMasterID:0,
  //   AssetNumber:null,
  //   SerialNumber:null,
  //   Manufacturer:null,
  //   Model:null,
  //   WarrantyExpiryDate:null as any,
  //   WarrantyExpiryDateObj:null as any,
  //   Cost:null,
  //   Remarks:null,
  //   Description:null,
  //   Attachment:null,
  //   AllotmentId:0
  // }
  dtoptions: DataTables.Settings = {};
  constructor(
    private AssetService: AssetService,
    private modalService: NgbModal,
    private combo: ComboService,
    public dateFormate: CustomDateParserFormatter,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
    private utility: UtilityService,
    private session: SessionService,
    protected common: CommonService

  ) {
    this.route.params.subscribe(params => this.AssetAdditionDetails.ESS_AssetAdditionId = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }


  ngOnInit(): void {
    this.selectedFiles = new Array(this.TableDatas.length).fill(null);
    this.SelectDate('RegistrationDate', null, null);
    if (this.AssetAdditionDetails.ESS_AssetAdditionId > 0) {
      this.LoadAssetMaster();
      this.IsDisableAdd = false;
      ;
    }
    this.ComboLoad('Branch');
    this.ComboLoad('AssetMaster');
  }
  addRowsToTable(): void {
    const count = this.AssetAdditionDetails.TotalCount;
    if (!isNaN(count) && count > 0 && (count % 1 == 0)) {
      this.TableDatas = Array.from({ length: count }, (_, i) => ({
        ESS_AssetMasterID: null,
        AssetAdditionDetailsID: '',
        AssetNumber: '',
        SerialNumber: '',
        Manufacturer: '',
        Model: '',
        WarrantyExpiryDate: '',
        Cost: '',
        Remarks: '',
        Description: '',
        Attachment: ''
      }));
    }
    else {
      this.toast.show({ message: "Please enter only positive number in count", type: toastTypeEnum.warning });
    }

  }
  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branch = response.ComboLoad;
        }
        else if (Combotype == 'AssetMaster') {
          this.Asset = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  UpdateAssetDetails() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to save?';
    modalRef.result.then((result) => {
      if (result) {
        this.isDisabled = true;
        if (!this.AssetAdditionDetails.ESS_AssetAdditionDetails) {
          this.AssetAdditionDetails.ESS_AssetAdditionDetails = [];
        }
        this.AssetAdditionDetails.PurchaseDate = this.dateFormate.format(this.AssetAdditionDetails.PurchaseDateObj);
        this.TableDatas.forEach((element: any) => {
          console.log(this.TableDatas);
          this.AssetAdditionDetails.ESS_AssetAdditionDetails.push({
            ESS_AssetAdditionDetailsID: element.ESS_AssetAdditionDetailsId,
            ESS_AssetMasterID: element.ESS_AssetMasterID,
            AssetNumber: element.AssetNumber,
            SerialNumber: element.SerialNumber,
            Manufacturer: element.Manufacturer,
            Model: element.Model,
            WarrantyExpiryDate: this.dateFormate.format(element.WarrantyExpiryDateObj),
            WarrantyExpiryDateObj: element.WarrantyExpiryDateObj,
            Cost: element.Cost,
            Remarks: element.Remarks,
            Description: element.Description,
            Attachment: this.AssetAdditionDetails.Attachment,
            AllotmentId: this.AssetAdditionDetails.BranchId,
          });
        });

        this.AssetAdditionDetails.SelectType = 'Update';
        this.AssetService.InsertUpdateAssetAddition(this.AssetAdditionDetails).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              this.TableDatas = [];
              this.router.navigate(['/Asset/assetaddition/']);
            }
            else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
              this.AssetAdditionDetails.ESS_AssetAdditionDetails = [];
            }

            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }
  selectedFiles: (File | null)[] = [];
  handleFileInput(event: any, index: number) {
    const file = event.target.files[0];
    this.selectedFiles[index] = file;
  }
  SaveAssetDetails() {
    console.log("print", this.AssetAdditionDetails);

    this.AssetService.PORefrenceNumberDublicateCheck(this.AssetAdditionDetails).subscribe({

      next: (response) => {
        if (response.Error_Code == '266') {
          console.log("response");

          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = "The purchase refresh number you're trying to save already exists. Do you still want to save it?";
          modalRef.result.then((result) => {
            if (result) {
              const modalRef = this.modalService.open(ConfirmationComponent);
              modalRef.componentInstance.Message = 'Do you want to save?';
              modalRef.result.then((result) => {
                if (result) {
                  this.isDisabled = true;
                  this.AssetAdditionDetails.Attachment = this.AssetAdditionDetails.Attachment;
                  this.AssetAdditionDetails.PurchaseDate = this.dateFormate.format(this.AssetAdditionDetails.PurchaseDateObj);


                  this.TableDatas.forEach((element: any) => {
                    console.log(this.TableDatas);
                    this.AssetAdditionDetails.ESS_AssetAdditionDetails.push({
                      ESS_AssetAdditionDetailsID: element.ESS_AssetAdditionDetailsId,
                      ESS_AssetMasterID: element.ESS_AssetMasterID,
                      AssetNumber: element.AssetNumber,
                      SerialNumber: element.SerialNumber,
                      Manufacturer: element.Manufacturer,
                      Model: element.Model,
                      WarrantyExpiryDate: this.dateFormate.format(element.WarrantyExpiryDateObj),
                      WarrantyExpiryDateObj: element.WarrantyExpiryDateObj,
                      Cost: element.Cost,
                      Remarks: element.Remarks,
                      Description: element.Description,

                      AllotmentId: this.AssetAdditionDetails.BranchId,
                    });
                  });

                  console.log(this.AssetAdditionDetails.ESS_AssetAdditionDetails);

                  this.AssetService.InsertUpdateAssetAddition(this.AssetAdditionDetails).subscribe({
                    next: (response) => {
                      if (response.Error_Code == '01') {
                        this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                        this.TableDatas = [];
                        this.router.navigate(['/Asset/assetaddition/']);
                      }
                      else {
                        this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                        this.AssetAdditionDetails.ESS_AssetAdditionDetails = [];
                      }

                      this.isDisabled = false;
                    },
                    complete: () => { },
                    error: (error) => {
                      this.isDisabled = false;
                    },
                  });
                }
              });


            }
          }
          )
        }

        else {
          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = 'Do you want to save?';
          modalRef.result.then((result) => {
            if (result) {
              this.isDisabled = true;
              this.AssetAdditionDetails.Attachment = this.AssetAdditionDetails.Attachment;
              this.AssetAdditionDetails.PurchaseDate = this.dateFormate.format(this.AssetAdditionDetails.PurchaseDateObj);
              this.TableDatas.forEach((element: any) => {
                this.AssetAdditionDetails.ESS_AssetAdditionDetails.push({
                  ESS_AssetAdditionDetailsID: element.ESS_AssetAdditionDetailsID,
                  ESS_AssetMasterID: element.ESS_AssetMasterID,
                  AssetNumber: element.AssetNumber,
                  SerialNumber: element.SerialNumber,
                  Manufacturer: element.Manufacturer,
                  Model: element.Model,
                  WarrantyExpiryDate: this.dateFormate.format(element.WarrantyExpiryDateObj),
                  WarrantyExpiryDateObj: element.WarrantyExpiryDateObj,
                  Cost: element.Cost,
                  Remarks: element.Remarks,
                  Description: element.Description,

                  AllotmentId: this.AssetAdditionDetails.BranchId,
                });
              });
              this.AssetService.InsertUpdateAssetAddition(this.AssetAdditionDetails).subscribe({
                next: (response) => {
                  if (response.Error_Code == '01') {
                    this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                    this.TableDatas = [];
                    this.router.navigate(['/Asset/assetaddition/']);
                  }
                  else {
                    this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                    this.AssetAdditionDetails.ESS_AssetAdditionDetails = []
                  }

                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          });

        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });



  }
  Validate(form: any) {
    if (form.valid) {
      if (this.TableDatas.length === 0) {
        this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
        return
      }
      if (this.AssetAdditionDetails.ESS_AssetAdditionId > 0) {

        this.UpdateAssetDetails()

      }
      else {

        this.SaveAssetDetails();
      }
    }
    else {
      form.submitted = true;
    }
  }

  LoadAssetMaster() {
    this.isDisabled = true;
    this.AssetService.LoadAssetAdditionDetail({ SelectType: 1, ESS_AssetAdditionId: this.AssetAdditionDetails.ESS_AssetAdditionId }).subscribe({
      next: (response) => {
        this.AssetAdditionDetails.SelectType = 'Update';
        this.AssetAdditionDetails = response[0];
        const attachmentPath = this.AssetAdditionDetails.Attachment;
        // if (attachmentPath) {
        //   const lastIndex = attachmentPath.lastIndexOf('\\');
        //   if (lastIndex !== -1) {
        //     this.AssetAdditionDetails.Attachment = attachmentPath.substring(lastIndex + 1);
        //     console.log(this.AssetAdditionDetails.Attachment);

        //   }
        // }
        this.AssetAdditionDetails.AttachmentUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AssetAdditionAttachment' + '/' + response[0].Attachment;
        this.AssetAdditionDetails.Attachment = response[0].Attachment;
        const dateMoment = moment(response[0].PurchaseDate);
        this.AssetAdditionDetails.PurchaseDateObj = {
          year: dateMoment.year(),
          month: dateMoment.month() + 1, // NgbDateStruct month is 1-based
          day: dateMoment.date(),
        };
        this.TableDatas = Object.values(response);
        this.TableDatas.forEach((element: any) => {
          const dateMoment1 = moment(response[0].WarrantyExpiryDate);
          element.WarrantyExpiryDateObj = {
            year: dateMoment1.year(),
            month: dateMoment1.month() + 1, // NgbDateStruct month is 1-based
            day: dateMoment1.date(),
          };

        });

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.MaxDate = moment(response.Table[0].RegistrationDate);
          this.MinDate = moment(this.AssetAdditionDetails.PurchaseDateObj)
        }
      },
      complete: () => {
        const Datemoment = this.MaxDate;
        this.MaxDate.Date = {
          year: Datemoment.year(),
          month: Datemoment.month() + 1, // NgbDateStruct month is 1-based
          day: Datemoment.date(),
        };
        this.MinDate.Date = {
          year: Datemoment.year(),
          month: Datemoment.month() + 1, // NgbDateStruct month is 1-based
          day: Datemoment.date(),
        }
      },
      error: (error) => { },
    });
  }
  upload(event: any, Folder: any) {
    try {
      this.isDisabled = true;
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
          if (response.FileName != "") {
            this.AssetAdditionDetails.Attachment = response.FileName;
            this.AssetAdditionDetails.AttachmentUrl = response.Url;
          } else {
            this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.danger });
          }
          this.isDisabled = false;
        }, (error) => {
          this.isDisabled = false;
        });
      };
    } catch (e) { }
  }
  uploadAssetDetails(event: any, Folder: any): Observable<any> {
    return new Observable((observer) => {
      try {
        this.isDisabled = true;
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
            if (response.FileName != "") {
              observer.next({ FileName: response.FileName, Url: response.Url });
            } else {
              this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.danger });
            }
            this.isDisabled = false;
            observer.complete();
          }, (error) => {
            this.isDisabled = false;
            observer.error(error);
          });
        };
      } catch (e) {
        observer.error(e);
      }
    });
  }
  CheckDublicateRefreshNumber() {
    this.AssetService.PORefrenceNumberDublicateCheck({ PurchaseRefNo: 'PO-ABC-12345' }).subscribe({
      next: (response) => {
        if (response.Error_Code == '266') {
          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = 'purchase refresh number already exist?';
          modalRef.result.then((result) => {
            if (result) {


            }
          }
          )
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });

  }
  ValidateInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57 || charCode == 191) {
      return;
      event.preventDefault();
    }
  }
}
